export const SEO_DESCRIPTION =
  "Book consultations with the world's top design experts"
export const WEBSITE_TITLE = 'The Expert'
